<template lang="pug">
  list(title="Passed Due Invoice" :items="invoice" :loading="loading")
</template>

<script>
import List from '../components/List'
import invoiceService from '../service.js'
export default {
  name: 'passed-due-invoice',
  data() {
    return {
      invoice: [],
      loading: true
    }
  },
  components: {
    List
  },
  created() {
    this.getPassedDueInvoice()
  },
  activated() {
    this.getPassedDueInvoice()
  },
  methods: {
    getPassedDueInvoice() {
      this.loading = true
      return invoiceService
      .getPassedDueInvoice()
      .then((response) => {
        console.log('open invoice list', response)
        this.invoice = response.data
        this.loading = false
        return response
      })
    }
  }
}
</script>

<style scoped>
</style>